import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, MessageCircle, X } from 'lucide-react';

const Footer = () => {
  // Footer link tıklama işleyicisi
  const handleFooterNavigation = () => {
    // Sayfanın en üstüne scroll yap
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(59,130,246,0.15)_1px,transparent_0)] bg-[length:20px_20px]"></div>
      </div>
      
      {/* Top Border */}
      <div className="relative">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500 to-transparent"></div>
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-px bg-gradient-to-r from-primary-400 via-primary-500 to-primary-400"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Main Footer Content */}
        <div className="py-4 lg:py-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* Company Info - 4 columns */}
            <div className="lg:col-span-4">
              <div className="space-y-4">
                {/* Logo */}
                <div className="text-center">
                  <div className="w-14 h-14 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center shadow-lg mx-auto mb-2">
                    <img src="/footerlogo.png" alt="Flekspro Logo" className="w-8 h-8 filter brightness-0 invert" />
                  </div>
                  <h3 className="text-xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent mb-1">
                    Flekspro
                  </h3>
                  <p className="text-primary-400 text-sm font-medium mb-4">
                    Esnek ve Profesyonel
                  </p>
                </div>

                                 {/* Social Media */}
                 <div className="text-center space-y-3">
                   <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider -mt-2.5">
                     Bizi Takip Edin
                   </h4>
                  <div className="flex justify-center space-x-3">
                    <a href="https://www.facebook.com/Flekspro/" target="_blank" rel="noopener noreferrer" className="group w-9 h-9 bg-slate-800/50 border border-slate-700/50 rounded-lg flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:border-primary-500 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-primary-500/25" aria-label="Facebook">
                      <Facebook size={16} className="group-hover:scale-110 transition-transform duration-300" />
                    </a>
                    <a href="https://x.com/flekspro" target="_blank" rel="noopener noreferrer" className="group w-9 h-9 bg-slate-800/50 border border-slate-700/50 rounded-lg flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:border-primary-500 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-primary-500/25" aria-label="X (Twitter)">
                      <X size={16} className="group-hover:scale-110 transition-transform duration-300" />
                    </a>
                    <a href="https://www.instagram.com/flekspro/" target="_blank" rel="noopener noreferrer" className="group w-9 h-9 bg-slate-800/50 border border-slate-700/50 rounded-lg flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:border-primary-500 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-primary-500/25" aria-label="Instagram">
                      <Instagram size={16} className="group-hover:scale-110 transition-transform duration-300" />
                    </a>
                    <a href="https://www.linkedin.com/company/flekspro" target="_blank" rel="noopener noreferrer" className="group w-9 h-9 bg-slate-800/50 border border-slate-700/50 rounded-lg flex items-center justify-center text-slate-400 hover:bg-primary-600 hover:border-primary-500 hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-primary-500/25" aria-label="LinkedIn">
                      <Linkedin size={16} className="group-hover:scale-110 transition-transform duration-300" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Links - 8 columns */}
            <div className="lg:col-span-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
                
                {/* Main Menu */}
                <div className="space-y-3">
                  <h4 className="text-base font-bold text-white relative">
                    Menü
                    <div className="absolute -bottom-1 left-0 w-8 h-0.5 bg-gradient-to-r from-primary-500 to-primary-400 rounded-full"></div>
                  </h4>
                  <ul className="space-y-3">
                    <li>
                      <Link to="/hakkimizda" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Hakkımızda
                      </Link>
                    </li>
                    <li>
                      <Link to="/hizmetler" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Hizmetler
                      </Link>
                    </li>
                    <li>
                      <Link to="/referanslar" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Referanslar
                      </Link>
                    </li>
                    <li>
                      <Link to="/hizmet-al" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Hizmet Al
                      </Link>
                    </li>
                    <li>
                      <Link to="/hizmet-ver" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Hizmet Ver
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Legal Links */}
                <div className="space-y-3">
                  <h4 className="text-base font-bold text-white relative">
                    Yasal
                    <div className="absolute -bottom-1 left-0 w-8 h-0.5 bg-gradient-to-r from-primary-500 to-primary-400 rounded-full"></div>
                  </h4>
                  <ul className="space-y-3">
                    <li>
                      <Link to="/kullanim-kosullari" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Kullanım Koşulları
                      </Link>
                    </li>
                    <li>
                      <Link to="/sartlar-kosullar" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Şartlar ve Koşullar
                      </Link>
                    </li>
                    <li>
                      <Link to="/gizlilik-politikasi" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Gizlilik Politikası
                      </Link>
                    </li>
                    <li>
                      <Link to="/cerez-politikasi" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        Çerez Politikası
                      </Link>
                    </li>
                    <li>
                      <Link to="/kisisel-veriler-korunmasi" onClick={handleFooterNavigation} className="group flex items-center text-gray-300 hover:text-primary-400 transition-all duration-300 text-sm">
                        <span className="w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                        KVKK
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Contact Info */}
                <div className="space-y-3">
                  <h4 className="text-base font-bold text-white relative">
                    İletişim
                    <div className="absolute -bottom-1 left-0 w-8 h-0.5 bg-gradient-to-r from-primary-500 to-primary-400 rounded-full"></div>
                  </h4>
                  <ul className="space-y-3">
                    <li className="group">
                      <a href="mailto:info@flekspro.com" className="flex items-start space-x-2 hover:scale-105 transition-transform duration-300">
                        <div className="w-8 h-8 bg-gradient-to-br from-primary-500/20 to-primary-600/20 border border-primary-500/30 rounded-lg flex items-center justify-center text-primary-400 group-hover:bg-primary-600 group-hover:text-white group-hover:border-primary-500 transition-all duration-300 flex-shrink-0">
                          <Mail size={14} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-gray-300 group-hover:text-white transition-colors duration-300 text-xs font-medium">Email</p>
                          <p className="text-gray-400 text-xs">info@flekspro.com</p>
                        </div>
                      </a>
                    </li>
                    <li className="group">
                      <a href="tel:08505325989" className="flex items-start space-x-2 hover:scale-105 transition-transform duration-300">
                        <div className="w-8 h-8 bg-gradient-to-br from-primary-500/20 to-primary-600/20 border border-primary-500/30 rounded-lg flex items-center justify-center text-primary-400 group-hover:bg-primary-600 group-hover:text-white group-hover:border-primary-500 transition-all duration-300 flex-shrink-0">
                          <Phone size={14} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-gray-300 group-hover:text-white transition-colors duration-300 text-xs font-medium">Telefon</p>
                          <p className="text-gray-400 text-xs">0850 532 59 89</p>
                        </div>
                      </a>
                    </li>
                    <li className="group">
                      <a href="https://maps.google.com/?q=Şirinyalı+mah.+1513+sk.+No:+9/2+Muratpaşa+Antalya" 
                         target="_blank" 
                         rel="noopener noreferrer" 
                         className="flex items-start space-x-2 hover:scale-105 transition-transform duration-300">
                        <div className="w-8 h-8 bg-gradient-to-br from-primary-500/20 to-primary-600/20 border border-primary-500/30 rounded-lg flex items-center justify-center text-primary-400 group-hover:bg-primary-600 group-hover:text-white group-hover:border-primary-500 transition-all duration-300 flex-shrink-0">
                          <MapPin size={14} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-gray-300 group-hover:text-white transition-colors duration-300 text-xs font-medium">Adres</p>
                          <p className="text-gray-400 text-xs leading-relaxed">
                            Şirinyalı mah. 1513 sk.<br />No: 9/2 Muratpaşa/Antalya
                          </p>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
                 <div className="border-t border-slate-700/50 py-5">
           <div className="flex flex-col lg:flex-row justify-between items-center space-y-3 lg:space-y-0">
            {/* Copyright */}
            <div className="text-center lg:text-left">
              <p className="text-gray-400 text-xs">
                © 2025 <Link to="/hakkimizda" onClick={handleFooterNavigation} className="text-primary-400 font-semibold hover:text-primary-300 transition-colors duration-300 cursor-pointer">Flekspro A.Ş.</Link> Tüm hakları saklıdır.
              </p>
            </div>

            {/* Bottom Links */}
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs">
              <Link to="/online-odeme" onClick={handleFooterNavigation} className="text-gray-400 hover:text-primary-400 transition-colors duration-300 font-medium">
                Online Ödeme
              </Link>
              <div className="w-px h-4 bg-gray-500"></div>
              <Link to="/musteri" onClick={handleFooterNavigation} className="text-gray-400 hover:text-primary-400 transition-colors duration-300 font-medium">
                Müşteri
              </Link>
              <div className="w-px h-4 bg-gray-500"></div>
              <Link to="/partner" onClick={handleFooterNavigation} className="text-gray-400 hover:text-primary-400 transition-colors duration-300 font-medium">
                Partner
              </Link>
              <div className="w-px h-4 bg-gray-500"></div>
              <Link to="/aydinlatma-metinleri" onClick={handleFooterNavigation} className="text-gray-400 hover:text-primary-400 transition-colors duration-300 font-medium">
                Aydınlatma Metinleri
              </Link>
              <div className="w-px h-4 bg-gray-500"></div>
              <Link to="/politikalar" onClick={handleFooterNavigation} className="text-gray-400 hover:text-primary-400 transition-colors duration-300 font-medium">
                Politikalar
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
